import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { Modal } from '../Component.js';
import { Content } from '../components/content/Component.js';
import { Controls } from '../components/controls/Component.js';
import { Footer } from '../components/footer/Component.js';
import { Header } from '../components/header/Component.js';

var ModalMobileComponent = forwardRef(function (props, ref) { return (React.createElement(Modal, __assign({}, props, { ref: ref, view: 'mobile' }))); });
var ControlsMobile = Controls;
var ModalMobile = Object.assign(ModalMobileComponent, {
    Content: Content,
    Header: Header,
    Footer: Footer,
    Controls: ControlsMobile,
});

export { Content as ContentMobile, ControlsMobile, Footer as FooterMobile, Header as HeaderMobile, ModalMobileComponent as ModalComponentMobile, ModalMobile };
